import { Drawer } from "@material-ui/core";
import React from "react";
import MenuOptions from "../../components/MenuOptions/MenuOptions";
import UserInfo from "../../components/UserInfo/UserInfo";
import { State, Type } from "../DrawerMain/DrawerMain";
import { useStyles } from "./DrawerMobileStyles";

type Props = {
  menuState: State,
  menuAction: (type: Type) => void,
};

export const DrawerMobile = ({ menuState, menuAction }: Props) => {
  const classes = useStyles();
  const onClose = () => menuAction(Type.CLOSE);
  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={menuState.open}
      onClose={onClose}
      classes={{
        paper: classes.drawerPaper,
      }}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <>
        <UserInfo />
        <MenuOptions />
      </>
    </Drawer>
  );
};
